module.exports = __webpack_public_path__ + "assets/CMidpointDetailed.fdf4f4e394f892c7e6f5116ba7672a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CMidpointDetailed.png
// module id = 475
// module chunks = 0